import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ChatBubbleOvalLeftEllipsisIcon, BoltIcon } from "@heroicons/react/24/outline";
import EtModalContactReflection from "@/components/modal/EtModalContactReflection";

export default function EtContact() {


  // First Created - 15 Aug 2025
  // Author - Atul Pandey
  // Updated - 09 Oct 2025 - Refined for greater engagement
  // Updated - 10 Oct 2025 - Refined for greater engagement
  // Updated - 02 Nov 2025 - Refined for continued engagement
  // Updated - 02 Nov 2025 - Timer to show elapsed time to reach CTA


  // 1 - Local UI state
  const [open, setOpen] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(""); // 02 Nov 2025

  // 2 - Timer effect
  useEffect(() => {
  if (typeof window !== "undefined") {
    const start = parseInt(sessionStorage.getItem("trinity.startTime"), 10);
    const end = parseInt(sessionStorage.getItem("trinity.endTime"), 10);

    if (!isNaN(start) && !isNaN(end)) {
      const diffInSeconds = Math.floor((end - start) / 1000);
      const minutes = Math.floor(diffInSeconds / 60);
      const seconds = diffInSeconds % 60;
      setElapsedTime(`${minutes}m ${seconds}s`);
    }
  }
}, []);

  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     const start = parseInt(sessionStorage.getItem("trinity.startTime"), 10);
  //     if (!isNaN(start)) {
  //       const interval = setInterval(() => {
  //         const now = Date.now();
  //         const diffInSeconds = Math.floor((now - start) / 1000);
  //         const minutes = Math.floor(diffInSeconds / 60);
  //         const seconds = diffInSeconds % 60;
  //         setElapsedTime(`${minutes}m ${seconds}s`);
  //       }, 1000);

  //       return () => clearInterval(interval); // Cleanup
  //     }
  //   }
  // }, []);

  return (
    <section id="contact" className="relative py-24 bg-gradient-to-b from-black via-black/95 to-black text-white">
      {/* Ambient pulse to match EtEternityCTA */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-orange-600/20 to-black animate-[pulse_15s_ease-in-out_infinite]" />
      <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">               
        
        {/* 1) Headline */}
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-white"
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        >
          {/* Start a <span className="text-orange-500">Trinity</span> Conversation */}
          {/* Continue the <span className="text-orange-500">Trinity</span> Conversation */}
          {/* Let’s Deepen the <span className="text-orange-500">Trinity</span> Dialogue */}
          Your <span className="text-orange-500">Trinity</span> Reflection Deserves a Follow-Through
        </motion.h2>

        {/* 2) Subcopy */}
        {/* <p className="mt-4 text-gray-300 max-w-2xl mb-6 mx-auto">
          Thank you for giving yourself the time to reflect. Ready to turn these insights into actions? Get a spark in your inbox—and let’s explore the next phase of your growth with Eternity.
        </p> */}
        <p className="mt-4 text-gray-300 max-w-4xl mb-6 mx-auto font-light">
          Awesome! In just <span className="text-white font-semibold rounded-full bg-orange-600 px-2">{elapsedTime}</span>, you sparked a shift toward a greater future by giving yourself the time to reflect. Why <span className="text-orange-600 font-bold"></span>stop now? Choose a time and get a <strong className="text-orange-600 animate-pulse">spark</strong> in your inbox—and let’s explore the next phase of your growth with Eternity.
        </p>

        {/* 3) Reflection Summary */}
        {typeof window !== "undefined" && (() => {
          const data = JSON.parse(localStorage.getItem("trinity.reflectionData") || "{}");
          const { growthDefinition, thinkingSelected = [], purposeSelected = [], habitsSelected = [], reflectionQuestions = {} } = data;

          return (
            <div className="bg-white/10 p-6 py-2 rounded-lg text-left text-gray-100 mb-2">
              <h3 className="text-xl font-bold mb-4 text-white">Your Trinity Reflection Summary</h3>

              {/* <div className="w-full max-w-xs mx-auto my-8 h-px bg-orange-500/40 animate-pulse" /> */}
              <div className="w-full mx-auto my-1 h-px bg-orange-500/40 animate-pulse" />

              {/* 3b) Time Elapsed */}
              {/* {elapsedTime && (
                <p className="text-sm text-gray-400 italic mt-2 mb-4">
                  You've been reflecting for <span className="text-white font-medium rounded-full bg-white px-2">{elapsedTime}</span>—every second well spent.
                </p>
              )} */}

              {growthDefinition && <p className="py-1"><strong className="text-orange-600 mx-1">Growth Definition:</strong> <span className="font-light">{growthDefinition}</span> </p>}
              {thinkingSelected.length > 0 && <p className="py-1"><strong className="text-orange-600 mx-1">Current Thinking State:</strong> <span className="font-light">{thinkingSelected.join(", ")}</span></p>}
              {purposeSelected.length > 0 && <p className="py-1"><strong className="text-orange-600 mx-1">Purpose focus:</strong> <span className="font-light">{purposeSelected.join(", ")}</span></p>}
              {habitsSelected.length > 0 && <p className="py-1"><strong className="text-orange-600 mx-1">Habits to shift:</strong> <span className="font-light">{habitsSelected.join(", ")}</span></p>}
              <br />
              <p className="text-white font-bold">Seed Questions for further probing:</p>
              <div className="w-full mx-auto my-1 h-px bg-orange-500/40 animate-pulse" />
              <ol className="list-decimal list-inside text-sm font-extralight py-1 text-orange-600">
                <li className="py-1 text-white/80">{reflectionQuestions.thinkingQ || "—"}</li>
                <li className="py-1 text-white/80">{reflectionQuestions.purposeQ || "—"}</li>
                <li className="py-1 text-white/80">{reflectionQuestions.habitsQ || "—"}</li>
              </ol>
            </div>
          );
        })()}

        {/* {elapsedTime && (
          <div className="text-sm text-gray-200 mt-6 mb-4 max-w-xl mx-auto">
            In just <span className="text-white font-semibold rounded-full bg-orange-400 px-2">{elapsedTime}</span>, you sparked a shift toward a greater future.
            <br className="my-1" />
            <span className="text-white/90 font-medium">Why stop now?</span> Choose a time to take the next step below.
          </div>
        )} */}


        {/* 4) Trigger */}
        <motion.button
          onClick={() => setOpen(true)}
          className="mt-4 inline-flex items-center gap-2 px-6 py-3 bg-white text-orange-600 font-semibold rounded-lg shadow-lg hover:bg-gray-100 transition"
          whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.97 }}
          aria-haspopup="dialog" aria-expanded={open}
        >
          {/* <ChatBubbleOvalLeftEllipsisIcon className="h-6 w-6" /> */}
          <BoltIcon className="h-6 w-6" />
          {/* Start the Conversation */}
            {/* Continue the Conversation */}
            {/* Get My Growth Summary */}
            Send Me the Spark
            {/* Let’s Talk Growth */}
            {/* Ready to Go Deeper */}
        </motion.button>
      </div>

      {/* 5) Modal */}
      {/* {open && <EtModalContactReflection open={open} onClose={() => setOpen(false)} />} */}
      
      {/* 02 Nov 2025 */}
      {open && (
        <EtModalContactReflection
          open={open}
          onClose={() => {
            setOpen(false);               // ✅ Close the modal
            window.scrollTo(0, 0);        // Scroll to top immediately
            window.location.reload();     // ✅ Then reload the page
          }}
        />
      )}
    </section>
  );
}
